import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'VLOOKUP',
  category: FunctionCategory.LOOKUP,
  description:
    'Lookup a certain value in one column and return a value from a different column in the same row.',
  shortDescription: 'Lookup in one column and return a value from another column',
  params: [
    {
      name: 'column_to_search',
      type: ArgType.any,
      description: 'A column to search for a certain value.',
    },
    {
      name: 'value_to_search_for',
      type: ArgType.any,
      description: 'A value to search for.',
    },
    {
      name: 'column_to_return',
      type: ArgType.any,
      description: 'A column to return a value from.',
    },
  ],
} satisfies AnalysisFunction;
